import React from 'react';
import { motion } from 'framer-motion';

export const Hero = () => {
  return (
    <div className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1502680390469-be75c86b636f?q=80&w=2070&auto=format&fit=crop")' }}
      >
        <div className="absolute inset-0 bg-[#0a192f]/60 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f] via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <span className="inline-block py-1 px-3 rounded-full bg-[#93e9be]/20 text-[#93e9be] border border-[#93e9be]/30 text-sm font-bold tracking-widest uppercase mb-6 backdrop-blur-sm">
            Catch the next set
          </span>
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold text-white tracking-tight mb-8 drop-shadow-lg">
            RIDE THE <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#93e9be] to-[#ff7f50]">ENERGY</span>
          </h1>
          <p className="text-lg md:text-2xl text-gray-200 mb-10 max-w-2xl mx-auto drop-shadow-md">
            Premium coastal surf gear and apparel engineered for the dedicated waterman.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="#boards" className="group relative inline-flex items-center justify-center px-8 py-4 font-bold text-white transition-all duration-200 bg-[#ff7f50] font-pj rounded-full hover:bg-[#e66c3e] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#ff7f50]">
              Shop Boards
              <SafeIcon name="ArrowRight" className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#bundle" className="inline-flex items-center justify-center px-8 py-4 font-bold text-white transition-all duration-200 bg-transparent border-2 border-white rounded-full hover:bg-white hover:text-[#0a192f] focus:outline-none">
              Explore Bundles
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};